import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ title }) => {
    return (
        <Helmet>
            <title>{title ? `${title} | ${process.env.REACT_APP_WEBSITE_NAME}` : `${process.env.REACT_APP_WEBSITE_NAME}`}</title>
        </Helmet>
    )
}

export default SEO;